import { render, staticRenderFns } from "./SaleStat.vue?vue&type=template&id=77e247d8&scoped=true&"
import script from "./SaleStat.vue?vue&type=script&lang=js&"
export * from "./SaleStat.vue?vue&type=script&lang=js&"
import style0 from "./SaleStat.vue?vue&type=style&index=0&id=77e247d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e247d8",
  null
  
)

export default component.exports